var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card-code',{attrs:{"no-body":""}},[_c('b-table',{staticStyle:{"text-align":"center"},attrs:{"responsive":"sm","items":_vm.items}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }